import { AxiosError } from 'axios';
import { DropDownItem } from 'web-library';
import { ConfigurationType } from 'web-library/models/DropDown';
import { PaginatedData } from 'web-library/models/List';
import { POST_JOB_STATUS_REPORTS_MUTATION_URL } from '../../constants/apiUrls';
import { JobNameModel } from '../../models/JobName';
import { ApiPathParam } from '../../models/SearchParamSchema';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// ============================================================================

export interface JobStatusReportsContent {
  personnelInfo: string[];
  candidateInfo: string[];
  recordInfo: string[];
  uuid: string;
  filename?: string;
  examLevel?: string;
  syncAttemptDate: string;
  recordStatus: DropDownItem;
  noOfAttempts: number;
  retryable: boolean;
}

export interface JobStatusReportsPayload {
  jobName: JobNameModel;
  startDate: string;
  endDate: string;
  examLevels?: Pick<ConfigurationType, 'code'>[];
  recordStatus?: Pick<ConfigurationType, 'code'>;
  q?: string;
  apiPathParams: ApiPathParam;
}

type JobStatusReportsResponse = {
  jobName: JobNameModel;
  result: PaginatedData<JobStatusReportsContent>;
};
// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: JobStatusReportsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAdminJobStatusReports = ({ onSuccess, onError }: Input = {}) => {
  const postAdminJobStatusReports = async ({
    apiPathParams,
    ...requestBody
  }: JobStatusReportsPayload) => {
    const res = await axiosClient.post<JobStatusReportsResponse>(
      POST_JOB_STATUS_REPORTS_MUTATION_URL(apiPathParams),
      requestBody
    );
    return res.data;
  };

  return useCustomMutation(postAdminJobStatusReports, {
    onSuccess,
    onError,
  });
};
